import { render, staticRenderFns } from "./TaskListToolbar.vue?vue&type=template&id=3a60da3a"
import script from "./TaskListToolbar.vue?vue&type=script&lang=js"
export * from "./TaskListToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports